import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Bouton retour */}
        <Link
          to="/"
          className="inline-flex items-center text-honey-600 hover:text-honey-700 mb-8"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          Retour à l'accueil
        </Link>

        {/* Titre */}
        <h1 className="text-3xl font-bold text-slate-900 mb-8">
          Politique de confidentialité
        </h1>

        {/* Contenu */}
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
          {/* 1. Responsable du traitement */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Responsable du traitement</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Le responsable du traitement est le Syndicat Apicole de la Réunion (SAR).
            </p>
          </section>

          {/* 2. Données collectées */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Données collectées</h2>
            <p className="text-slate-600 leading-relaxed mb-4 text-justify">
              Dans le cadre de l'adhésion et de l'utilisation de la plateforme, les données suivantes peuvent être collectées :
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Identité (nom, prénom, raison sociale)</li>
              <li>Coordonnées (adresse postale, email, téléphone)</li>
              <li>Données professionnelles et apicoles (NAPI, AMEXA, SIRET, nombre de ruches, localisation)</li>
              <li>Données de paiement (montant, statut, identifiants Stripe)</li>
              <li>Documents administratifs et signatures électroniques</li>
            </ul>
          </section>

          {/* 3. Finalités des traitements */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Finalités des traitements</h2>
            <p className="text-slate-600 leading-relaxed mb-4 text-justify">
              Les données sont traitées pour :
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>La gestion des adhésions</li>
              <li>Le calcul des cotisations</li>
              <li>La communication avec les adhérents</li>
              <li>La gestion des organes prévus aux statuts</li>
              <li>La génération de documents officiels</li>
              <li>Les obligations réglementaires et exports vers l'UNAF</li>
              <li>Les paiements et obligations comptables</li>
            </ul>
          </section>

          {/* 4. Bases légales */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Bases légales</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les traitements reposent sur :
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>L'exécution du contrat d'adhésion</li>
              <li>Les obligations légales</li>
              <li>L'intérêt légitime du SAR</li>
            </ul>
          </section>

          {/* 5. Partage des données */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Partage des données</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Les données peuvent être partagées avec :
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Les groupements apicoles partenaires</li>
              <li>L'UNAF (Union Nationale de l'Apiculture Française)</li>
              <li>Les prestataires techniques (hébergement, paiement)</li>
            </ul>
          </section>

          {/* 6. Durée de conservation */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Durée de conservation</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Les données sont conservées pendant 3 ans après la fin de l'adhésion, sauf obligations légales spécifiques (comptabilité : 10 ans).
            </p>
          </section>

          {/* 7. Sécurité */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Sécurité</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Des mesures techniques et organisationnelles sont mises en œuvre pour assurer la sécurité des données.
            </p>
          </section>

          {/* 8. Droits des personnes */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Droits des personnes</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Conformément au RGPD, les adhérents disposent des droits d'accès, rectification, effacement, limitation et opposition.
            </p>
            <p className="text-slate-600 leading-relaxed mt-3">
              Les demandes peuvent être adressées à :{' '}
              <a href="mailto:abeillereunion@gmail.com" className="text-honey-600 hover:underline">
                abeillereunion@gmail.com
              </a>
            </p>
          </section>

          {/* 9. Réclamation */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Réclamation</h2>
            <p className="text-slate-600 leading-relaxed">
              Une réclamation peut être introduite auprès de la{' '}
              <a 
                href="https://www.cnil.fr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-honey-600 hover:underline"
              >
                CNIL
              </a>.
            </p>
          </section>
        </div>

        {/* Date de mise à jour */}
        <p className="text-sm text-slate-500 mt-6 text-center">
          Dernière mise à jour : Janvier 2026
        </p>
      </div>
    </div>
  );
}
